/**
 * @generated SignedSource<<fee961c1d41893644c2897efb691bff2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InfectopharmCountry = "Deutschland" | "Oesterreich" | "Unknown" | "%future added value";
export type Permission = "AccountPermission_System_Root" | "UserInAccountPermission_Brand_CreateBrand" | "UserInAccountPermission_Brand_DeleteBrand" | "UserInAccountPermission_Brand_ReadBrand" | "UserInAccountPermission_Brand_UpdateBrand" | "UserInAccountPermission_Certificates_CreateCertificates" | "UserInAccountPermission_Certificates_DeleteCertificates" | "UserInAccountPermission_Certificates_ReadCertificates" | "UserInAccountPermission_Certificates_UpdateCertificates" | "UserInAccountPermission_Export_CmeExport" | "UserInAccountPermission_Export_ExportNodes" | "UserInAccountPermission_Export_ExportPoints" | "UserInAccountPermission_Export_ExportSafe" | "UserInAccountPermission_Export_ExportUnsafe" | "UserInAccountPermission_Feedbacks_CreateFeedbacks" | "UserInAccountPermission_Feedbacks_DeleteFeedbacks" | "UserInAccountPermission_Feedbacks_ReadFeedbacks" | "UserInAccountPermission_Feedbacks_UpdateFeedbacks" | "UserInAccountPermission_Files_Delete" | "UserInAccountPermission_Import_BasisseminarImport" | "UserInAccountPermission_Import_ImportSafe" | "UserInAccountPermission_Import_ImportUnsafe" | "UserInAccountPermission_Import_InstitutionImport" | "UserInAccountPermission_Import_PACPointsImport" | "UserInAccountPermission_Import_SpecialAccessibleNodeImport" | "UserInAccountPermission_Import_UpdateEmailRequestImport" | "UserInAccountPermission_Instructors_CreateInstructors" | "UserInAccountPermission_Instructors_DeleteInstructors" | "UserInAccountPermission_Instructors_ReadInstructors" | "UserInAccountPermission_Instructors_UpdateInstructors" | "UserInAccountPermission_LandingPages_CreateLandingPages" | "UserInAccountPermission_LandingPages_DeleteLandingPages" | "UserInAccountPermission_LandingPages_ReadLandingPages" | "UserInAccountPermission_LandingPages_UpdateLandingPages" | "UserInAccountPermission_LearnStates_CreateLearnStates" | "UserInAccountPermission_LearnStates_DeleteLearnStates" | "UserInAccountPermission_LearnStates_ReadLearnStates" | "UserInAccountPermission_LearnStates_UpdateLearnStates" | "UserInAccountPermission_Maintenance_UpdateMaintenance" | "UserInAccountPermission_Management_Management" | "UserInAccountPermission_Messaging_CreateMessages" | "UserInAccountPermission_Messaging_DeleteMessages" | "UserInAccountPermission_Messaging_ReadMessages" | "UserInAccountPermission_Messaging_SendMessages" | "UserInAccountPermission_Messaging_UpdateMessages" | "UserInAccountPermission_ModuleRating_Read" | "UserInAccountPermission_NewsLetter_CreateNewsLetter" | "UserInAccountPermission_NewsLetter_DeleteNewsLetter" | "UserInAccountPermission_NewsLetter_ReadNewsLetter" | "UserInAccountPermission_NewsLetter_UpdateNewsLetter" | "UserInAccountPermission_NewsletterSubscription_ReadNewsletterSubscription" | "UserInAccountPermission_NewsletterSubscription_UpdateNewsletterSubscription" | "UserInAccountPermission_Newsticker_CreateMessages" | "UserInAccountPermission_Newsticker_DeleteMessages" | "UserInAccountPermission_Newsticker_ReadMessages" | "UserInAccountPermission_Newsticker_UpdateMessages" | "UserInAccountPermission_Nodes_CreateNodes" | "UserInAccountPermission_Nodes_DeleteNodes" | "UserInAccountPermission_Nodes_PublishNodes" | "UserInAccountPermission_Nodes_ReadNodes" | "UserInAccountPermission_Nodes_UpdateNodes" | "UserInAccountPermission_Points_CreatePoints" | "UserInAccountPermission_Points_DeletePoints" | "UserInAccountPermission_Points_ReadPoints" | "UserInAccountPermission_Points_UpdatePoints" | "UserInAccountPermission_Submissions_ReadSubmissions" | "UserInAccountPermission_System_Owner" | "UserInAccountPermission_Tags_CreateTags" | "UserInAccountPermission_Tags_DeleteTags" | "UserInAccountPermission_Tags_ReadTags" | "UserInAccountPermission_Tags_UpdateTags" | "UserInAccountPermission_Tracking_ReadTracking" | "UserInAccountPermission_TreeStateAdmin_Modify" | "UserInAccountPermission_TreeStateAdmin_Read" | "UserInAccountPermission_TriggerActionAdmin_Modify" | "UserInAccountPermission_TriggerActionAdmin_Read" | "UserInAccountPermission_User_DeleteUser" | "UserInAccountPermission_User_ReadEmailLog" | "UserInAccountPermission_User_ReadUserHistory" | "UserInAccountPermission_User_ReadUsers" | "UserInAccountPermission_User_ResendActivationEmail" | "UserInAccountPermission_User_RestoreUser" | "UserInAccountPermission_User_UpdateUserActivation" | "UserInAccountPermission_User_UpdateUserEmail" | "UserInAccountPermission_User_UpdateUserExtension" | "UserInAccountPermission_User_UpdateUserPassword" | "%future added value";
export type UserStatus = "active" | "activeEfnNeeded" | "changeInProgress" | "doccheck" | "doctorWithEfnInitialValidation" | "efnNeeded" | "inactive" | "initialValidation" | "noProcess" | "%future added value";
export type CurrentUser_Query$variables = {
  brandId: string;
};
export type CurrentUser_Query$data = {
  readonly Viewer: {
    readonly Auth: {
      readonly currentUser: {
        readonly permissionsInAccount: ReadonlyArray<Permission>;
        readonly user: {
          readonly extension: {
            readonly country?: InfectopharmCountry | null;
            readonly globalUserStatus?: UserStatus;
          } | null;
        };
      } | null;
    };
    readonly Privacy: {
      readonly UnacceptedPrivacy: {
        readonly content: string;
        readonly id: string;
      } | null;
    };
  };
};
export type CurrentUser_Query = {
  response: CurrentUser_Query$data;
  variables: CurrentUser_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "permissionsInAccount",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "userExtensionKind",
    "value": "InfectopharmUserExtension"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "globalUserStatus",
      "storageKey": null
    }
  ],
  "type": "InfectopharmUserExtension",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PrivacyViewerSchema",
  "kind": "LinkedField",
  "name": "Privacy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "brandId",
          "variableName": "brandId"
        }
      ],
      "concreteType": "Privacy",
      "kind": "LinkedField",
      "name": "UnacceptedPrivacy",
      "plural": false,
      "selections": [
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "content",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CurrentUser_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v2/*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CurrentUser_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v2/*: any*/),
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": "extension(userExtensionKind:\"InfectopharmUserExtension\")"
                      },
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "74f9711e9966f13ebff287594d81c367",
    "id": null,
    "metadata": {},
    "name": "CurrentUser_Query",
    "operationKind": "query",
    "text": "query CurrentUser_Query(\n  $brandId: ID!\n) {\n  Viewer {\n    Auth {\n      currentUser {\n        permissionsInAccount\n        user {\n          extension(userExtensionKind: InfectopharmUserExtension) {\n            __typename\n            ... on InfectopharmUserExtension {\n              country\n              globalUserStatus\n            }\n          }\n          id\n        }\n      }\n    }\n    Privacy {\n      UnacceptedPrivacy(brandId: $brandId) {\n        id\n        content\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4c8505cd8b77afa1197acbd8dd408931";

export default node;
